import { FileItem } from './FileItem';
export class Files {
    constructor(files) {
        this.files = new Map();
        this._size = 0;
        if (files) {
            for (const key in files) {
                const file = new FileItem(files[key]);
                this.add(file);
            }
        }
    }
    get length() {
        return this.files.size;
    }
    get size() {
        return this._size;
    }
    add(file) {
        if (this.files.get(file.name)) {
            throw new Error(`File ${file.name} already exist`);
        }
        this.files.set(file.name, file);
        this._size += file.size;
        return this;
    }
    get(name) {
        if (this.files.get(name)) {
            return this.files.get(name);
        }
        throw new Error(`File ${name} does not exist`);
    }
    has(name) {
        if (this.files.get(name)) {
            return true;
        }
        return false;
    }
    remove(name) {
        const file = this.get(name);
        this.files.delete(name);
        this._size -= file.size;
        return file;
    }
    list() {
        const files = [];
        this.files.forEach(value => {
            files.push(value);
        });
        return files;
    }
    forEach(callback) {
        const files = this.list();
        for (let index = 0; index < files.length; index++) {
            callback(files[index], index, this.files);
        }
    }
}
